var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-3"},[_vm._v(" Please set a permanent password, temporary password is valid only for the first time you login ")]),_c('ChangePassword',{attrs:{"is-loading":_vm.isLoading,"error-message":_vm.loginError.errorMessage},on:{"change-password":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }